import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "../../hooks/ScrollToTop";
import { motion } from "framer-motion";
import MainSection from "../HomeSections/MainSection";
import { notification } from "antd";
import { checkUserStatus } from "../../Api/userStatus";
import { setApiSlug } from "../../Api/Customapi";
import {
  InfoCircleOutlined,
  StopOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import TopHeader from "./TopHeader";
import UserStatusPopup from "../Popup/StatusPopup";
import AIAssistant from "../AiChat/AIAssistant";
import { useGetUserData } from "../../hooks/useGetUserData";
import { useDoctorQuery } from "../../hooks/useDoctorQuery";
import { DoctorContextProvider, useDoctorContext } from "../../context/DoctorContext";
import ReviewPopup from "../Popup/ReviewPopup";
import ReviewCarousel from "../Popup/ReviewCarouselPopup";
import LoginModal from "../Modals/LoginModal";
import { slug } from "../../utils/store";
import { useCenterData } from "../../hooks/useGetData";
import { useLanguage } from "../../context/LanguageContext";

const Layout = () => {
  const navigate = useNavigate();
useEffect(() => {
  sessionStorage.removeItem(`isGuestBooking-${slug}`);
  sessionStorage.removeItem(`guestInfo-${slug}`);
}, [slug])
  const location = useLocation();
  const showHeader =
    (location.pathname || "").includes("user-profile") ||
    location.pathname.includes("settings") ||
    location.pathname.includes("my-reports") ||
    location.pathname.includes("our-doctors") ||
    location.pathname.includes("/blog/") ||
    location.pathname.includes("/schedule-reminder") ||
    location.pathname.includes("/blog/") ||
    location.pathname.includes("/doctor-details") ||
    location.pathname.includes("/contact-us") ||
    location.pathname.includes("/clinics") ||
    location.pathname.includes("/packages") ||
    location.pathname.includes("/review") ||
    location.pathname.includes("/services");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const { data: user } = useGetUserData(slug);

  const [loginModal, setLoginModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isGuestModalVisible, setIsGuestModalVisible] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);

  const { data: doctor } = useDoctorQuery();
  const { language } = useLanguage();
  const {
    setHasReviews,
    setHasServices,
    setHasOffers,
    setHasBlogs,
    setHasNews,
    setHasDoctors,
  } = useDoctorContext();

  const { reviews, services, packages, blogs, news, doctors } =
    useCenterData(doctor?.id, language);

  // Set all flags once data resolves — no more scattered setHas* calls
  useEffect(() => { setHasReviews(reviews.data.length > 0);  }, [reviews.data]);
  useEffect(() => { setHasServices(services.data.length > 0); }, [services.data]);
  useEffect(() => { setHasOffers(packages.data.length > 0);  }, [packages.data]);
  useEffect(() => { setHasBlogs(blogs.data.length > 0);      }, [blogs.data]);
  useEffect(() => { setHasNews(news.data.length > 0);        }, [news.data]);
  useEffect(() => { setHasDoctors(doctors.data.length > 0);  }, [doctors.data]);
  const handleGuestBooking = () => {
    setIsModalVisible(false);
    setIsGuestModalVisible(true);
  };

  const handleGuestInfoSubmit = (guestInfo) => {
    setIsGuestModalVisible(false);
    sessionStorage.setItem(`guestInfo-${slug}`, JSON.stringify(guestInfo));
    sessionStorage.setItem(`isGuestBooking-${slug}`, "true");
    navigate(pendingRoute || `/book-appointment`);
  };

  useEffect(() => {
    setApiSlug(slug);
  }, [slug]);

  return (
    <div className="min-h-screen  flex flex-col">
        {contextHolder}
        <div className="flex-1 transition-all duration-300">
          {/* <TopHeader /> */}
          <Header
            registerModal={registerModal}
            setRegisterModal={setRegisterModal}
            user={user}
            loginModal={loginModal}
            setLoginModal={setLoginModal}
          />

          {!showHeader && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <MainSection
                setRegisterModal={setRegisterModal}
                isRegister={registerModal}
                loginModal={loginModal}
                setLoginModal={setLoginModal}
              />
            </motion.div>
          )}

          {/* Review Carousel - Shows on app load for multiple pending reviews */}
          <ReviewCarousel center={doctor} user={user} slug={slug} />
          <LoginModal
            setRegisterModal={setRegisterModal}
            isRegister={registerModal}
            loginModal={loginModal}
            setLoginModal={setLoginModal}
          />
          {/* Single Review Popup - Shows for current doctor if can review */}
          {doctor?.canReview && !doctor?.isReviewed && (
            <ReviewPopup doctor={doctor} user={user} slug={slug} />
          )}

          <UserStatusPopup />
          <main className="">
            <ScrollToTop />
            <Outlet />
          </main>
          {/* {doctor?.features.includes("chatbot_for_patient_support_&_follow-up") &&
          <AIAssistant
            isOpen={aiChatOpen}
            onToggle={() => setAiChatOpen(!aiChatOpen)}
            user={user}
            slug={slug}
          />} */}
          <Footer />
        </div>
    </div>
  );
};

export default Layout;
